var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProjectManagementIcon = function SvgProjectManagementIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 67,
    fill: "none",
    viewBox: "0 0 75 67"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M6.725 65a4.67 4.67 0 0 1-3.341-1.42A4.9 4.9 0 0 1 2 60.155V7.218a5.3 5.3 0 0 1 1.495-3.685A5.04 5.04 0 0 1 7.087 2h60.726a5.01 5.01 0 0 1 3.575 1.525 5.28 5.28 0 0 1 1.487 3.667v52.59a5.3 5.3 0 0 1-1.495 3.685A5.04 5.04 0 0 1 67.788 65z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M38.733 10.533h-25.6A2.133 2.133 0 0 0 11 12.667v25.6c0 1.178.955 2.133 2.133 2.133h25.6a2.133 2.133 0 0 0 2.134-2.133v-25.6a2.133 2.133 0 0 0-2.134-2.134M61.5 49h-15c-1.38 0-2.5.895-2.5 2v4c0 1.105 1.12 2 2.5 2h15c1.38 0 2.5-.895 2.5-2v-4c0-1.105-1.12-2-2.5-2M13.133 57.467h8.534M13.133 48.933h12.8M11.626 11.159l28.615 28.615M40.241 11.159 11.626 39.774M63.067 38.267v-25.6M55 38.6V13"
  })));
};
export default SvgProjectManagementIcon;